import React, { useEffect, useState } from 'react';
import { FiChevronRight } from 'react-icons/fi';
import { Link, useHistory } from 'react-router-dom';
import { useCart } from '../../hooks/CartHook';
import api from '../../services/api';

import whatsappIcon from '../../assets/whatsapp.png';

import './styles.css';

const formatPriceWithUnit = (item, value = item.preco) => {
  const price = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
  return item.unit_type ? `${price} / ${item.unit_type}` : price;
};


function Checkout() {
    const history = useHistory();
    const { itens: itensCart, observations, totalValue, clearCart, setName } = useCart();
    const [cliente, setCliente] = useState({});
    const [whatsapp, setWhatsapp] = useState('');
    const [cnpj, setCnpj] = useState('');
    const [cep, setCep] = useState('');
    const [cepAddress, setCepAddress] = useState('');

    if (itensCart.length === 0) {
        history.push('/');
    }

    const subdominio = window.location.hostname.split('.')[0];

    useEffect(() => {
        api.get(`clientes/${subdominio}`).then(response =>{
            const clienteResponse = response?.data?.[0];
            setCliente(clienteResponse || {});

            if (clienteResponse?.id) {
                localStorage.setItem('cliente_id', String(clienteResponse.id));
            }
        })
    }, [subdominio]);

    function getAuthorizationId() {
        if (cliente?.id) {
            return String(cliente.id);
        }

        const localClienteId = localStorage.getItem('cliente_id');
        if (localClienteId) {
            return localClienteId;
        }

        return '';
    }

    function formatPhone(value) {
        const onlyNumbers = value.replace(/\D/g, '').slice(0, 11);
        if (onlyNumbers.length <= 2) return onlyNumbers ? `(${onlyNumbers}` : '';
        if (onlyNumbers.length <= 6) return `(${onlyNumbers.slice(0, 2)}) ${onlyNumbers.slice(2)}`;
        if (onlyNumbers.length <= 10) return `(${onlyNumbers.slice(0, 2)}) ${onlyNumbers.slice(2, 6)}-${onlyNumbers.slice(6)}`;
        return `(${onlyNumbers.slice(0, 2)}) ${onlyNumbers.slice(2, 7)}-${onlyNumbers.slice(7)}`;
    }

    function formatCnpj(value) {
        const numbers = value.replace(/\D/g, '').slice(0, 14);
        return numbers
            .replace(/^(\d{2})(\d)/, '$1.$2')
            .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
            .replace(/\.(\d{3})(\d)/, '.$1/$2')
            .replace(/(\d{4})(\d)/, '$1-$2');
    }

    function formatCep(value) {
        const numbers = value.replace(/\D/g, '').slice(0, 8);
        return numbers.replace(/^(\d{5})(\d)/, '$1-$2');
    }

    async function handleCreateOrderButton() {
        const nome = document.getElementById('name').value;
        const cnpjValue = document.getElementById('cnpj')?.value || '';
        const cepValue = document.getElementById('cep')?.value || '';

        if (!nome || !whatsapp) {
            alert('Preencha os campos para continuar.');
            return;
        }
        if (cliente?.aceitar_cnpj && !cnpjValue) {
            alert('Preencha o CNPJ para continuar.');
            return;
        }
        if (cliente?.aceitar_cep && !cepValue) {
            alert('Preencha o CEP para continuar.');
            return;
        }

        setName(nome);

        const authorizationId = getAuthorizationId();
        if (!authorizationId) {
            alert('Não foi possível identificar a loja. Recarregue a página e tente novamente.');
            return;
        }

        const itens = itensCart.map(item => ({ id: item.id, nome: item.nome, quantidade: item.amount }));

        const body = {
            cliente_id: Number(authorizationId),
            nome: nome,
            meio_pagamento: 'PIX',
            whatsapp: whatsapp,
            observacao: observations,
            valor: totalValue,
            itens: itens,
            cnpj: cnpjValue,
            cep: cepValue,
            endereco_cep: cepAddress,
        }

        let response;

        try {
            response = await api.post(`pedidos`, body, {
                headers: {
                    'authorization': authorizationId
                }
            });
        } catch (error) {
            if (error?.response?.status === 401) {
                alert('Sessão da loja não autorizada. Recarregue a página e tente novamente.');
                return;
            }
            alert('Não foi possível finalizar o pedido via Pix. Tente novamente.');
            return;
        }

        if (response.data === "Stock insuficiente" || response.data === "Estoque insuficiente") {
            alert('Algum produto do carrinho não tem estoque suficiente. Tente realizar o pedido novamente.');

            clearCart();

            history.push('/');

            return;
        }

        const orderState = {
            pedidoId: response.data?.id,
            name: nome,
            totalValue,
        };

        localStorage.setItem('last_order_data', JSON.stringify(orderState));
        clearCart();
        history.push('/pedido-pix', orderState);
    }

    async function handleCreateOrderViaWhatsapp() {
        const nome = document.getElementById('name').value;
        const cnpjValue = document.getElementById('cnpj')?.value || '';
        const cepValue = document.getElementById('cep')?.value || '';

        if (!nome || !whatsapp) {
            alert('Preencha os campos para continuar.');
            return;
        }
        if (cliente?.aceitar_cnpj && !cnpjValue) {
            alert('Preencha o CNPJ para continuar.');
            return;
        }
        if (cliente?.aceitar_cep && !cepValue) {
            alert('Preencha o CEP para continuar.');
            return;
        }

        const authorizationId = getAuthorizationId();
        if (!authorizationId) {
            alert('Não foi possível identificar a loja. Recarregue a página e tente novamente.');
            return;
        }

        const itens = itensCart.map(item => ({ id: item.id, name: item.nome, quantidade: item.amount  }));

        const body = {
            cliente_id: Number(authorizationId),
            nome: nome,
            meio_pagamento: 'whatsapp',
            whatsapp: whatsapp,
            observacao: observations,
            valor: totalValue,
            itens: itens,
            cnpj: cnpjValue,
            cep: cepValue,
            endereco_cep: cepAddress,
        }

        let response;
        try {
            response = await api.post(`pedidos`, body, {
                headers: {
                    'authorization': authorizationId,
                    'Content-Type': 'application/json'
                }
            });
        } catch (error) {
            if (error?.response?.status === 401) {
                alert('Sessão da loja não autorizada. Recarregue a página e tente novamente.');
                return;
            }
            alert('Não foi possível finalizar o pedido por WhatsApp. Tente novamente.');
            return;
        }


        if (response.data === "Stock insuficiente" || response.data === "Estoque insuficiente") {
            alert('Algum produto do carrinho não tem estoque suficiente. Tente adicionar novamente.');

            clearCart();

            history.push('/');

            return;
        }

        let pedido = '';
        itens.forEach((item, index) => {
            pedido += `${item.name} x ${item.quantidade} ${index === (itens.length - 1) ? '.' : ', '}`;
        });

        const price = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(totalValue);

        let message = `Olá *${cliente.nome_empresa}*, tenho um novo pedido:

        *Nome:* ${nome}
        *Pedido:* ${pedido}
        *Valor:* ${price}
        ${observations ? `*Obs.:* ${observations}
` : ''}
        Aguardo sua confirmação.`

        message = window.encodeURIComponent(message);

        const phoneNumber = String(cliente.whatsapp || '').replace(/\D/g, '');
        const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;
        const orderState = {
            pedidoId: response.data?.id,
            whatsappUrl,
        };

        localStorage.setItem('last_whatsapp_order', JSON.stringify(orderState));
        clearCart();
        history.push('/pedido-whatsapp', orderState);
    }

    return (
        <div id="checkout_container">
            <header>
                <Link to="/carrinho">
                    Voltar ao carrinho
                    <FiChevronRight size={16}></FiChevronRight>
                </Link>
            </header>
            <main>
                <h1>Checkout</h1>

                <div className="inputs_container">
                    <input type="text" id="name" placeholder="Seu nome" required />

                    <input
                        type="tel"
                        id="whatsapp"
                        placeholder="Celular"
                        value={whatsapp}
                        onChange={(event) => setWhatsapp(formatPhone(event.target.value))}
                        required
                    />

                    {!!cliente.aceitar_cnpj && (
                        <input
                            type="text"
                            id="cnpj"
                            placeholder="CNPJ"
                            value={cnpj}
                            onChange={(event) => setCnpj(formatCnpj(event.target.value))}
                            required
                        />
                    )}

                    {!!cliente.aceitar_cep && (
                        <>
                            <input
                                type="text"
                                id="cep"
                                placeholder="CEP de entrega"
                                value={cep}
                                onChange={(event) => {
                                    setCep(formatCep(event.target.value));
                                    setCepAddress('');
                                }}
                                required
                            />
                            {cepAddress && <small className="cepAddress">{cepAddress}</small>}
                        </>
                    )}
                </div>

                <div className="buttons_container">
                    {!!cliente.aceitar_pix && (
                        <button
                            className="pixButton"
                            onClick={handleCreateOrderButton}
                        >
                            Pedir via Pix
                        </button>
                    )}

                    {!!cliente.aceitar_whatsapp && (
                        <button
                            className="whatsButton"
                            onClick={handleCreateOrderViaWhatsapp}
                        >
                            Pedir por WhatsApp
                            <img src={whatsappIcon} alt="WhatsApp" />
                        </button>
                    )}
                </div>

                <div className="order">
                    <h3>Resumo do pedido</h3>

                    <div id="itens_container">
                        {itensCart.map((item, index) => (
                            <div className="item" key={index}>
                                <div className="item_info">
                                    {item.imagem && (
                                        <img src={item.imagem} alt={item.name} />
                                    )}

                                    <div className="item_desc">
                                        <p>{item.nome}</p>
                                        <p>Quantidade: {item.amount}</p>
                                        <span>Unidade: {formatPriceWithUnit(item)}</span><br/>
                                        <span>Total: {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(item.preco * item.amount)}</span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </main>
        </div>
    );
}

export default Checkout;
